export default __webpack_public_path__ + "pgnv-assets/158813035b30bd68ed951f339c0a2e2f.png";